import { Component, OnInit } from '@angular/core';

declare var RDStationForms: any;
declare var RSSParser: any;

@Component({
  selector: 'app-noticias',
  templateUrl: './noticias.component.html',
  styleUrls: ['./noticias.component.css']
})
export class NoticiasComponent implements OnInit {

  public feed: any;

  constructor() { }

  ngOnInit() {
    new RDStationForms('aditt-nit-25522eae8c231bed5a4a', 'UA-2727336-2').createForm();

    // const URL_RSS = "http://www.unesc.net/portal/rss/index/824"
    const URL_RSS = "http://www.unesc.net/portal/rss/index/213"
    const CORS_PROXY = "https://cors-anywhere.herokuapp.com/"
    let parser = new RSSParser();
    parser.parseURL(CORS_PROXY + URL_RSS, (err, feed) => {
      if (err) throw err;
      console.log(feed.title);
      feed.items.forEach((entry) => {
        console.log(entry.title + ':' + entry.link);
        console.log(entry);
        var regex = /(&nbsp;|<([^>]+)>)/ig
        entry.contentSnippetHtmlSafe = entry.contentSnippet.replace(regex, "");


        const reg = /(src=')(.*)(')/g;
        let match = reg.exec(entry.contentSnippet)
        entry.image = match[2] || 'http://www.unesc.net/portal/resources/assets/template/59//images/unesc-brand.svg';
      });

      this.feed = feed;
    });

  }

}
